import { useEffect, useState } from "react";

const LINKS = [
  { id: "manifesto", label: "Approach" },
  { id: "expect", label: "The Session" },
  { id: "instructor", label: "About" },
  { id: "pricing", label: "Pricing" },
  { id: "testimonials", label: "Clients" },
];

const scrollTo = (id) => {
  const target = document.getElementById(id);
  if (!target) return;
  if (window.__lenis) window.__lenis.scrollTo(target, { offset: -80 });
  else target.scrollIntoView({ behavior: "smooth" });
};

export default function Nav() {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        solid ? "bg-[#FAF7F2]/85 backdrop-blur-xl border-b border-[#1C1917]/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-14 h-20 md:h-24 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("top")}
          className="font-display text-xl md:text-2xl tracking-tight text-[#1C1917] leading-none text-left"
        >
          Jessica Bacon<span className="text-[#2D4A3E]">.</span>
          <span className="block label text-[#78716C] mt-1 text-[0.55rem]">Private Pilates · Hampstead, London</span>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="label text-[#57534E] hover:text-[#2D4A3E] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-book-btn"
          onClick={() => scrollTo("booking")}
          className="btn-lux hidden md:inline-flex items-center rounded-full bg-[#18181B] text-[#FAF7F2] px-6 py-3 label hover:bg-[#2D4A3E]"
        >
          Book a Session
        </button>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden font-mono-pp text-sm text-[#1C1917]"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? "CLOSE" : "MENU"}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#FAF7F2] border-t border-[#1C1917]/10 px-5 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-link-${l.id}`}
              onClick={() => { scrollTo(l.id); setOpen(false); }}
              className="label text-left text-[#1C1917]"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-book-btn"
            onClick={() => { scrollTo("booking"); setOpen(false); }}
            className="rounded-full bg-[#18181B] text-[#FAF7F2] px-6 py-3 label text-center"
          >
            Book a Session
          </button>
        </div>
      )}
    </header>
  );
}
